module.exports = __webpack_public_path__ + "9567c41c08b8501e913c6b7ce36e47c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Logos/PPN_ASSETS/WalletCard_2023_MyCanadaPlan_en.jpg
// module id = 1565
// module chunks = 0